module.exports = __webpack_public_path__ + "static/img/1661.d6a10c0.png";